import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { Counter } from '@dfds-pax/shared-components/client'

type Props = {
  dataE2e: string
  description?: string
  label: string
  maxValue: number
  minValue: number
  name: string
  onChange: (value: number) => void
  value: number
}

const PassengerCounterRow: React.FC<Props> = ({ dataE2e, description, label, maxValue, minValue, name, onChange, value }) => {
  const groupRef = useRef<HTMLDivElement>(null)
  const steppedRef = useRef(false)
  const labelId = `passenger-${name}-label`
  const { t } = useTranslation()

  // A step button becomes disabled at its limit, which would otherwise drop focus to the document.
  useEffect(() => {
    if (!steppedRef.current) return
    steppedRef.current = false
    const group = groupRef.current
    if (!group || group.contains(document.activeElement)) return
    group.querySelector<HTMLButtonElement>('button:not([disabled])')?.focus()
  }, [value])

  return (
    <li
      className="m-0 flex h-[66px] list-none flex-row items-center p-0 py-semantic-global-md border-b border-solid border-semantic-global-border-light first:pt-0 last:border-0 last:pb-0"
      data-e2e={dataE2e}
    >
      <div className="mr-auto">
        <div className="font-medium text-semantic-global-text-default" id={labelId}>
          {label}
        </div>
        {description ? <div className="text-sm font-normal text-semantic-global-text-light">{description}</div> : null}
      </div>
      <div aria-labelledby={labelId} ref={groupRef} role="group">
        <Counter
          maxValue={maxValue}
          minValue={minValue}
          name={name}
          onChange={(next) => {
            steppedRef.current = true
            onChange(next)
          }}
          value={value}
          t={t}
        />
      </div>
    </li>
  )
}

export default PassengerCounterRow
